module.exports = __webpack_public_path__ + "img/logo.f2903523.svg";